import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Col, Form, Row, Image, Button } from "react-bootstrap";
import Switch from "react-switch";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  makeStyles,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { super_admin_add_diner_reservation } from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../../../function/InputCharNumCheckFunc";
import { get_all_vendor_seating_information } from "../../../../../store/actions/SuperAdminActions/adminSeatingDashboardAllAction";
import store from "../../../../../store/store";
import { SET_VENDOR_INFORMATION } from "../../../../../store/types";
import { withRouter } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const selectedSeating = [
  { id: 1, name: "any", value: "any" },
  { id: 2, name: "patio", value: "patio" },
  { id: 3, name: "outdoor", value: "outdoor" },
  { id: 4, name: "porch", value: "porch" },
  { id: 5, name: "bar", value: "bar" },
];

const AdminAddReservation = () => {
  const classes = useStyles();
  //state
  const history = useHistory();
  const [state, setState] = useState({
    isLoading: false,
    number: "",
    name: "",
    highChairHandiCapped: false,
    roomNumber: "",
    tableNumber: "",
    seatingPreference: "",
    specialOcassion: "",
  });
  const [code, setCode] = useState("");
  const [adult, setAdult] = useState(0);
  const [kids, setKids] = useState(0);
  const [handicap, setHandicap] = useState(0);
  const [highchair, setHighchair] = useState(0);

  const vendorInfo = useSelector((state) => {
    return state.adminAllVendorsInfo.superAdminVendorInfo;
  });

  const token = useSelector((state) => {
    return state.auth.user.accessToken;
  });

  const dispatch = useDispatch();

  const [country_code, setCountryCode] = useState("");
  useEffect(() => {
    axios
      .get("https://ipapi.co/json")
      .then((result) => setCountryCode(result.data.country_calling_code))
      .catch((error) =>
        setCountryCode({
          error,
        })
      );
  }, []);

  const handleChangeCode = (event) => {
    setCountryCode(event.target.value);
  };

  const onChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const onChangeNumber = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    setState({
      ...state,
      [e.target.name]: number,
    });
  };

  const IncrementKidsItem = (e) => {
    e.preventDefault();
    if (adult === 0) {
      if (kids < 100) {
        setKids(kids + 1);
        setAdult(adult + 1);
      } else {
        setKids(kids + 1);
      }
    } else {
      setKids(kids + 1);
    }
  };
  const IncrementAdultItem = (e) => {
    e.preventDefault();
    if (adult < 100) {
      setAdult(adult + 1);
    } else {
      return null;
    }
  };
  const IncrementhandicapItem = (e) => {
    e.preventDefault();
    if (handicap < 100) {
      setHandicap(handicap + 1);
    } else {
      return null;
    }
  };
  const IncrementhighchairItem = (e) => {
    e.preventDefault();
    if (highchair < 100) {
      setHighchair(highchair + 1);
    } else {
      return null;
    }
  };

  const DecreaseKidsItem = (e) => {
    e.preventDefault();
    if (kids > 0) {
      setKids(kids - 1);
    } else {
      return null;
    }
  };

  const DecreaseAdultItem = (e) => {
    e.preventDefault();
    if (adult > 0) {
      setAdult(adult - 1);
    } else {
      return null;
    }
  };

  const DecreaseHandicapItem = (e) => {
    e.preventDefault();
    if (handicap > 0) {
      setHandicap(handicap - 1);
    } else {
      return null;
    }
  };
  const DecreaseHighchairItem = (e) => {
    e.preventDefault();
    if (highchair > 0) {
      setHighchair(highchair - 1);
    } else {
      return null;
    }
  };

  const [seatingPreference, setSeatingPreference] = useState("");
  /***************************
   * @DESC on Button Handler
   ***************************/
  const onButtonClick = (e, type) => {
    e.preventDefault();
    setSeatingPreference({
      seatingPreference: type,
    });
  };

  const handleSubmit = (e) => {
    const formData = {
      kids_count: kids,
      adult_count: adult,
      handicap_chair: handicap,
      high_chair: highchair,
      occasion: state.specialOcassion,
      pointOfEntry: "SuperAdmin",
      location: {
        latitude: 26.23794,
        longitude: 78.14626,
      },
      seating_preference: seatingPreference.seatingPreference,
      service_type: "RESERVATION",
      user_details: {
        country_code: code,
        deviceToken: "",
        mobile_number: state.number,
        name: state.name,
      },
      vendor_id: vendorInfo.vendor_id,
    };
    dispatch(super_admin_add_diner_reservation(formData, token, onSuccess));
  };

  const onSuccess = (e) => {
    const newData = vendorInfo;
    store.dispatch({
      type: SET_VENDOR_INFORMATION,
      payload: newData,
    });
    const data = { vendor_id: vendorInfo.vendor_id };
    dispatch(get_all_vendor_seating_information(data));
    history.push({
      pathname: "/superadminseatingdashboard",
      state: { data: newData },
    });
  };

  const selecthandleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  const [checkedBox, setCheckedBox] = useState(false);
  const handleChangeSwitch = (e) =>
    setCheckedBox({ checkedBox: !checkedBox.checkedBox });

  return (
    <React.Fragment>
      <Form className="py-4">
        <Row>
          <Col md={12} lg={10} xl={8}>
            <Row>
              <Col md={6}>
                <Row>
                  <Col xs={4} className="pr-0">
                    <Form.Group controlId={"country_code"}>
                      <FormControl variant="outlined" className="w-100">
                        <Select
                          value={country_code}
                          onChange={handleChangeCode}
                          inputProps={{
                            name: "country_code",
                          }}
                        >
                          {/* <option value={code}>{code}</option> */}
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+
                              {getCountryCallingCode(country)})
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </Form.Group>
                  </Col>
                  <Col xs={8}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Phone Number"
                        variant="outlined"
                        className="w-100"
                        value={state.number}
                        onChange={onChangeNumber}
                        type="number"
                        onKeyDown={InputNumberFunc}
                        inputProps={{
                          name: "number",
                          maxLength: 10,
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    id="outlined-basic"
                    label="Name"
                    variant="outlined"
                    className="w-100"
                    value={state.name}
                    onChange={onChange}
                    type="text"
                    onKeyDown={InputCharacterCheck}
                    inputProps={{
                      name: "name",
                      maxLength: 50,
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={12} lg={8}>
                <div className="f16-500 py-3">Party Size</div>
                <div className="d-flex enPartySize">
                  <div className="d-flex pr-3 pb-3">
                    <div className="enKidsIcon">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/children.png")}
                        alt="View"
                        title="View"
                        width="9px"
                      />
                    </div>
                    <div className="pl-md-2 enPartyPersonEdit">
                      <div className="f14-500 pb-2">Kids</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={DecreaseKidsItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                            alt="Remove"
                            title="Remove"
                            fluid
                          />
                        </Button>
                        <input
                          placeholder="00"
                          className="enInputValueOnly f12-700"
                          value={kids}
                        />
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={IncrementKidsItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                            alt="Add"
                            title="Add"
                            fluid
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex border-left pl-3 pb-3">
                    <div className="enKidsIcon">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/employees.png")}
                        alt="View"
                        title="View"
                        width="9px"
                      />
                    </div>
                    <div className="pl-md-2 enPartyPersonEdit">
                      <div className="f14-500 pb-2">Adult</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={DecreaseAdultItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                            alt="Remove"
                            title="Remove"
                            fluid
                          />
                        </Button>
                        <input
                          placeholder="00"
                          className="enInputValueOnly f12-700"
                          value={adult}
                        />
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={IncrementAdultItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                            alt="Add"
                            title="Add"
                            fluid
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center pb-4">
                  <div className="f16-500">
                    Need Handicap access or a Highchair?
                  </div>
                  <div className="d-flex align-items-center py-4 pl-md-4">
                    <div className="f16-500 mr-2">No</div>
                    <Switch
                      onChange={handleChangeSwitch}
                      checked={checkedBox.checkedBox}
                      offColor="#EEEEEE"
                      onColor="#EEEEEE"
                      offHandleColor="#212121"
                      onHandleColor="#59F832"
                      handleDiameter={24}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      height={15}
                      width={41}
                      boxShadow="-2px 0px 5px #0000003B"
                      activeBoxShadow="-2px 0px 5px #0000003B"
                      id="material-switch"
                      // disabled={disabled === true ? true : false}
                    />
                    <div className="f16-500 ml-2">Yes</div>
                  </div>
                </div>
                <div className="d-flex enPartySize pb-4">
                  <div className="d-flex pr-3 pb-3">
                    <div className="enKidsIcon">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/wheelchair.png")}
                        alt="View"
                        title="View"
                        className="custom"
                      />
                    </div>
                    <div className="pl-md-2 enPartyPersonEdit">
                      <div className="f14-500 pb-2">Handicap</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={DecreaseHandicapItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                            alt="Remove"
                            title="Remove"
                            fluid
                          />
                        </Button>
                        <input
                          placeholder="00"
                          className="enInputValueOnly f12-700"
                          value={handicap}
                        />
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={IncrementhandicapItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                            alt="Add"
                            title="Add"
                            fluid
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex border-left pl-3 pb-3">
                    <div className="enKidsIcon">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/highchair.svg")}
                        alt="View"
                        title="View"
                        className="custom"
                      />
                    </div>
                    <div className="pl-md-2 enPartyPersonEdit">
                      <div className="f14-500 pb-2">Highchair</div>
                      <div className="d-flex align-items-center">
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={DecreaseHighchairItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/minus.svg")}
                            alt="Remove"
                            title="Remove"
                            fluid
                          />
                        </Button>
                        <input
                          placeholder="00"
                          className="enInputValueOnly f12-700"
                          value={highchair}
                        />
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={IncrementhighchairItem}
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/plus.svg")}
                            alt="Add"
                            title="Add"
                            fluid
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <Row>
                  <Col md={6}>
                    <TextField
                      label="Reservation Date"
                      variant="outlined"
                      type="date"
                      className="w-100"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="start_date"
                    />
                  </Col>
                  <Col md={6}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-time">
                        Reservation Time
                      </InputLabel>
                      <Select
                        value={state.time}
                        onChange={selecthandleChange}
                        label="Reservation Time"
                        inputProps={{
                          name: "time",
                          id: "outlined-time",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={"time"}>time</option>
                      </Select>
                    </FormControl>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md={5}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Room No."
                        variant="outlined"
                        className="w-100"
                        value={state.roomNumber}
                        onChange={onChangeNumber}
                        type="number"
                        onKeyDown={InputNumberFunc}
                        inputProps={{
                          name: "roomNumber",
                          maxLength: 3,
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={5}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Table No."
                        variant="outlined"
                        className="w-100"
                        value={state.tableNumber}
                        onChange={onChangeNumber}
                        type="number"
                        onKeyDown={InputNumberFunc}
                        inputProps={{
                          name: "tableNumber",
                          maxLength: 3,
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="f16-500 pb-1 pt-3">Seating Preference</div>
                    <div className="f12-400 pb-3">
                      Seating is a subject to availability. Your Preference will
                      be considered.
                    </div>
                  </Col>
                  {vendorInfo.selected_seating_area &&
                    vendorInfo.selected_seating_area.map((item, index) => (
                      <Col md={4} key={index}>
                        <div
                          className="enCheckWithText w-100"
                          onChange={(e) => onButtonClick(e, item.title)}
                        >
                          <input type="radio" name="SeatingPreference" />
                          <label className="w-100 d-flex align-items-center justify-content-center">
                            {/* <Image
                              src={require("../../../../../assets/images/UserManagement/chairs.svg")}
                              alt="chairs"
                              title="chairs"
                              className="mr-2"
                            /> */}
                            {item.title}
                          </label>
                        </div>
                      </Col>
                    ))}
                </Row>
              </Col>
              <Col md={12}>
                <div className="f16-500 pt-3 pb-2">Special Occasion</div>
                <Form.Group>
                  <TextField
                    id="outlined-multiline-static"
                    multiline
                    rows={5}
                    placeholder="eg. Wedding Anniversary"
                    variant="outlined"
                    className="w-100"
                    value={state.specialOcassion}
                    onChange={onChange}
                    type="text"
                    inputProps={{
                      name: "specialOcassion",
                    }}
                  />
                </Form.Group>
                <div className="d-flex align-items-center pt-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={onSuccess}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="btn150px btn-lg px-5"
                    onClick={handleSubmit}
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default withRouter(AdminAddReservation);
